import { createAction } from '@reduxjs/toolkit';
import { IEntityReducer } from 'core/reducers/entities';
import { IRegisterReducer } from 'core/slices/register';
import { ISessionReducer } from 'core/slices/session';
import { EntityTypes } from '../../../constants/entities';
import { IQueue } from 'core/slices/queue';

export interface IUpdateState {
  id?: number;
  type: EntityTypes;
  culprit?: any;
}

export const updateState = createAction('state/update', function prepare(entity: IUpdateState) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const restoreState = createAction('state/restore', function prepare(updates: IUpdateState[]) {
  return {
    payload: updates,
  };
});

export interface IStart {
  id?: number;
  type: EntityTypes;
  isContinue?: boolean;
  preview?: boolean;
  moduleId?: number;
  auto: boolean;
}

export const start = createAction('start', function prepare(entity: IStart) {
  return {
    payload: {
      ...entity,
    },
  };
});

export interface IHydrate {
  prodEnt: IEntityReducer;
  session: ISessionReducer;
  register: IRegisterReducer;
  queue: IQueue;
  offlineId: number;
}

export const hydrate = createAction('hydrate', function prepare(entity: Partial<IHydrate>) {
  return {
    payload: entity,
  };
});

export interface IPersist {
  prodEnt: boolean;
  session: boolean;
  register: boolean;
}

export const persist = createAction('persist', function prepare(entity: Partial<IPersist>) {
  return {
    payload: entity,
  };
});
